import React from 'react'
import Select from 'react-select'
import { get, some, every, isEmpty, filter, isPresent } from 'lodash'

const filteredData = ({ vms, filters }) => filter(vms, (vm) => {
  const filterResults = {}

  if (filters.sites != 'all') {
    filterResults['sites'] = some(filters.sites, site => site.value === get(vm, 'site.code'))
  }

  if (filters.customers != 'all') {
    filterResults['customers'] = some(filters.customers, customer => customer.value === get(vm, 'customer.id'))
  }

  if (filters.showPresentCustomers != 'all') {
    filterResults['showPresentCustomers'] = filters.showPresentCustomers === isPresent(vm.customer)
  }

  if (filters.inSite != 'all') {
    filterResults['inSite'] = isPresent(vm.site) === filters.inSite
  }

  return (every(filterResults, (value, key) => value === true) || isEmpty(filterResults))
})

const VMReportFilters = ({ filters, changeFilters, filterOptions }) => {
  return (
    <div className="container-fluid" style={{ marginTop: '10px', marginBottom: '10px' }}>
      <div className="row">
        <div className="col col-3">
          <label htmlFor="CustomersFilter">
            Matched customers:
            <div className="input-group">
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <input
                    type="radio"
                    name="showPresentCustomersFilterAll"
                    id="showPresentCustomersFilterAll"
                    checked={filters.showPresentCustomers === 'all'}
                    onClick={_ => changeFilters({ ...filters, showPresentCustomers: 'all' })}
                  />
                  <span style={{ marginLeft: '5px' }}>All</span>
                </div>
              </div>
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <input
                    type="radio"
                    name="showPresentCustomersFilterTrue"
                    id="showPresentCustomersFilterTrue"
                    checked={filters.showPresentCustomers === true}
                    onClick={_ => changeFilters({ ...filters, showPresentCustomers: true })}
                  />
                  <span style={{ marginLeft: '5px' }}>Matched</span>
                </div>
              </div>
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <input
                    type="radio"
                    name="showPresentCustomersFilterTrue"
                    id="showPresentCustomersFilterTrue"
                    checked={filters.showPresentCustomers === false}
                    onClick={_ => changeFilters({ ...filters, showPresentCustomers: false })}
                  />
                  <span style={{ marginLeft: '5px' }}>Not matched</span>
                </div>
              </div>
            </div>
          </label>
        </div>
        <div className="col col-2">
          <label htmlFor="inSiteFilter">
            Matched to site:
            <div className="input-group">
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <input
                    type="radio"
                    name="inSiteFilterAll"
                    id="inSiteFilterAll"
                    checked={filters.inSite === 'all'}
                    onClick={_ => changeFilters({ ...filters, inSite: 'all' })}
                  />
                  <span style={{ marginLeft: '5px' }}>All</span>
                </div>
              </div>
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <input
                    type="radio"
                    name="inSiteFilterTrue"
                    id="inSiteFilterTrue"
                    checked={filters.inSite === true}
                    onClick={_ => changeFilters({ ...filters, inSite: true })}
                  />
                  <span style={{ marginLeft: '5px' }}>True</span>
                </div>
              </div>
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <input
                    type="radio"
                    name="inSiteFilterFalse"
                    id="inSiteFilterFalse"
                    checked={filters.inSite === false}
                    onClick={_ => changeFilters({ ...filters, inSite: false })}
                  />
                  <span style={{ marginLeft: '5px' }}>False</span>
                </div>
              </div>
            </div>
          </label>
        </div>
      </div>

      <div className='row'>
        <div className="col">
          Site
          <Select
            id='vmsSiteFilter'
            isMulti
            value={filters.sites}
            options={filterOptions.sites}
            onChange={options => {
              let sites = options
              if (isEmpty(options)) { sites = 'all' }

              changeFilters({ ...filters, sites })
            }}
          />
        </div>
        <div className="col">
          Customers
          <Select
            id='vmsSiteFilter'
            isMulti
            value={filters.customers}
            options={filterOptions.customers}
            onChange={options => {
              let customers = options
              if (isEmpty(options)) { customers = 'all' }

              changeFilters({ ...filters, customers })
            }}
          />
        </div>
      </div>
    </div>
  )
}

export { VMReportFilters, filteredData }
